import React, {useEffect, useState} from 'react'
import EnigooModal from "../../../../MyComponent/Modal/EnigooModal";
import {FiDownload, FiImage} from "react-icons/all";
import Widget from "../../../../components/widget";
import {Form} from "react-final-form";
import {EnigooSelect} from "../../../../MyComponent/EnigooSelect";
import {useTranslation} from "react-i18next";
import {FiCheck, FiX} from "react-icons/fi";
import {EnigooSwitch} from "../../../../MyComponent/EnigooSwitch";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {
    FILTER_BASICS,
    FILTER_CUSTOM_FIELDS, FILTER_DAYS, FILTER_ENTRANCES,
    FILTER_PRINT_MAIL,
    FILTER_REGISTRATION_WAY, getShownFilters
} from "../../../../reducers/filterUser";
import EnigooButton from "../../../../MyComponent/EnigooButton";

const UserFilterSetModal = () => {

    let [open, setOpen] = useState(false);
    let [initValues, setInitValues] = useState({});

    const {t} = useTranslation();

    let submit = null;
    const dispatch = useDispatch();
    const {filterUser} = useSelector(
        state => ({
            filterUser: state.reducerAdmin.filterUser
        }),
        shallowEqual
    )

    useEffect(() => {
        let initData = {};
        if (open) {
            initData = getShownFilters(filterUser);
        }
        setInitValues(initData);
    }, [open])

    const onSave = (values) => {
        dispatch({
            type: 'SET_SHOWN_FILTERS',
            shownFilters: values
        })
        onClose()
    }

    const onClose = () => {
        setOpen(false);
    }
    const onOpen = () => {
        setOpen(true);
    }

    const _renderForm = (form) => {
        return <div className={"flex flex-col space-x-2"}>
            <span className={"text-lg"}>{t("accreditation.filtersDesc")}</span>
            <div className={"flex flex-row space-x-2 w-1/2"}>
                <EnigooButton onClick={() => {
                    let object = {};
                    object[FILTER_BASICS] = true;
                    object[FILTER_CUSTOM_FIELDS] = true;
                    object[FILTER_PRINT_MAIL] = true;
                    object[FILTER_ENTRANCES] = true;
                    object[FILTER_REGISTRATION_WAY] = true;
                    object[FILTER_DAYS] = true;
                    form.initialize(object);
                }} icon={<FiCheck/>} text={t("basics.checkAll")}/>
                <EnigooButton color={"red"} onClick={() => {
                    let object = {};
                    object[FILTER_BASICS] = false;
                    object[FILTER_CUSTOM_FIELDS] = false;
                    object[FILTER_PRINT_MAIL] = false;
                    object[FILTER_ENTRANCES] = false;
                    object[FILTER_REGISTRATION_WAY] = false;
                    object[FILTER_DAYS] = false;
                    form.initialize(object);
                }} icon={<FiX/>} text={t("basics.uncheckAll")}/>

            </div>
            <div className={"grid grid-cols-4 gap-2"}>
                <EnigooSwitch label={t("basics.basicsFields")} name={FILTER_BASICS}/>
                <EnigooSwitch label={t("userFields.plural")} name={FILTER_CUSTOM_FIELDS}/>
                <EnigooSwitch label={t("basics.printMailFields")} name={FILTER_PRINT_MAIL}/>
                <EnigooSwitch label={t("deviceReports.entrances")} name={FILTER_ENTRANCES}/>
                <EnigooSwitch label={t("basics.registration")} name={FILTER_REGISTRATION_WAY}/>
                <EnigooSwitch label={t("action.days")} name={FILTER_DAYS}/>
            </div>
        </div>
    }

    return (
        <EnigooModal open={open} onOpen={onOpen} onClose={onClose} buttonText={t("basics.setFilters")}
                     title={t("basics.setFilters")} buttonColor={"grey"}
                     buttonIcon={<FiX/>} type={"smallbutton"} cancelText={t("basics.close")}
                     onSave={() => submit()} saveIcon={<FiCheck/>} saveText={t("basics.confirm")}>
            <Widget>
                <div className="flex flex-col">
                    <Form onSubmit={onSave} initialValues={initValues}
                          render={({handleSubmit, form}) => {
                              submit = handleSubmit;
                              return (
                                  _renderForm(form)
                              );
                          }}
                    />
                </div>
            </Widget>
        </EnigooModal>
    )
}
export default UserFilterSetModal;
